// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FormatPainterFilledSvg from "@ant-design/icons-svg/es/asn/FormatPainterFilled";
import AntdIcon from '../components/AntdIcon';

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterFilledSvg
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
export default /*#__PURE__*/React.forwardRef(FormatPainterFilled);